import React from 'react';
import useLocalization from './useLocalization';

/**
 * A dropdown component for selecting the application language
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} The language selector component
 */
const LanguageSelector = ({ className = '' }) => {
  const { language, languages, changeLanguage } = useLocalization();
  
  return (
    <select
      className={`font-sarabun bg-neutral_1 text-neutral_4 shadow-inner p-2 rounded-sm ${className}`}
      value={language}
      onChange={(e) => changeLanguage(e.target.value)}
      aria-label="Select language"
    >
      {Object.entries(languages).map(([code, { name }]) => (
        <option key={code} value={code}>
          {name}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelector;
